import { MatDialog } from '@angular/material/dialog';
import { ChangeDetectorRef, Component, HostListener, NgZone, OnInit } from '@angular/core';
import { SearchComponent } from './shared/components/search/search.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { cnpjValidator, emailValidator, phoneValidator } from './shared/utils/app-validators';
import { SwalService } from './shared/services/swal.service';
import { MetaService } from './shared/services/meta.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Blukit - O lado inteligente da hidráulica';
  collectiveVacation = '';
  showWhats = false;
  nameIsValid = false;
  formWhatsApp!: FormGroup;
  contato = '5547992343331'; // Telefone do WhatsApp para contato Mkt Blukit
  submitted = false;
  cookiesAccepted = false;

  darkModeEnabled = false;
  blindModeEnabled = false;
  vlibrasEnabled = false;
  vlibrasLoading = false;
  vlibrasLoadError = false;
  accessibilityModalOpen = false;
  hideAccessibilityBar = false;
  dontShowAgainChecked = false;
  vlibrasInstance: any = null;

  constructor(
    private matDialog : MatDialog,
    private fb: FormBuilder,
    private swalService: SwalService,
    private metaService: MetaService,
    private ngZone: NgZone,
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(){
    if (localStorage.getItem('cookiesAccepted')) {
      this.cookiesAccepted = true;
    }

    // Load accessibility preferences
    const darkModePref = localStorage.getItem('darkModePref') === 'true';
    if (darkModePref) {
      this.darkModeEnabled = true;
      document.body.classList.add('dark-mode');
    }

    // O modo de alto contraste não está mais disponível para seleção.
    document.body.classList.remove('modo-baixa-visao');
    localStorage.removeItem('blindModePref');

    const vlibrasPref = localStorage.getItem('vlibrasPref') === 'true';
    if (vlibrasPref) {
      this.vlibrasEnabled = true;
      this.scheduleVLibrasInit();
    }

    const hideBarPref = localStorage.getItem('hideAccessibilityBarPref') === 'true';
    if (hideBarPref) {
      this.hideAccessibilityBar = true;
      this.dontShowAgainChecked = true;
    }

    const setupDone = localStorage.getItem('accessibility_setup_done');
    if (!setupDone) {
      this.accessibilityModalOpen = true;
      setTimeout(() => {
        const firstOption = document.getElementById('btn-darkmode-pref');
        if (firstOption) {
          firstOption.focus();
        }
      }, 300);
    }

    this.metaService.getCanonicalUrl().subscribe(canonicalUrl => {
      this.addCanonicalLink(canonicalUrl);
    });

    this.metaService.getDescription().subscribe(description => {
      description.then((res) => {
        this.updateMetaTag('description', res);
        this.updateTitle(res);
      })
    });

    this.metaService.getOgUrl().subscribe(ogUrl => {
      this.updateMetaTag('og:url', ogUrl);
    });

    this.formWhatsApp = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(3)]],
      email: [null, Validators.compose([Validators.required, emailValidator])],
      telefone: [null, Validators.compose([Validators.required, phoneValidator])],
      cnpj: [null]
    })
  }

  private addCanonicalLink(canonicalUrl: string) {
    const link: HTMLLinkElement = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(link);
  }

  private updateMetaTag(property: string, content: string) {
    const tag = this.getOrCreateMetaTag(property);
    tag.setAttribute('content', content);
  }

  private getOrCreateMetaTag(property: string): HTMLMetaElement {
    const head = document.getElementsByTagName('head')[0];
    const tag = head.querySelector(`meta[name="${property}"]`);

    if (tag instanceof HTMLMetaElement) {
      return tag;
    } else {
      const newTag = document.createElement('meta');
      newTag.setAttribute('name', property);
      head.appendChild(newTag);
      return newTag;
    }

  }

  private updateTitle(title: string) {
    document.title = title; // Atualiza o título da página
  }
  openModalSearch(){
    document.body.classList.add('no-scroll');
    const dialogRef = this.matDialog.open(SearchComponent, {
      width: '100%',
      height: '100%',
    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('no-scroll');
    });
  }
  closeWhats(){
    this.showWhats = false;
  }
  openLgpd(){
    window.open('https://www.blukit.com.br/Politica-de-Privacidade-Blukit.pdf', 'target')
  }

  acceptCookies(){
    localStorage.setItem('cookiesAccepted', 'true');
    this.cookiesAccepted = true;
  }

  onSubmit(){
    this.submitted = true;
    if (!this.formWhatsApp.valid) {
      this.swalService.fireErrorSwal('Formulário não enviado','Existem campos obrigatórios não preenchidos.')
      return;
    }
    this.enviarMensagemWhats();


  }
  enviarMensagemWhats(){
    let urlApi = `https://wa.me/${this.contato}?`;

    let texto = `Olá. Gostaria de iniciar meu atendimento!%0ANome: ${ this.formWhatsApp.controls['nome'].value}%0ATelefone: ${ this.formWhatsApp.controls['telefone'].value}%0AEmail: ${ this.formWhatsApp.controls['email'].value}%0ACNPJ: ${ this.formWhatsApp.controls['cnpj'].value}`
    window.open(urlApi + "&text=" + texto, "_blank");
    this.showWhats = false;
  }

  toggleDarkMode() {
    this.darkModeEnabled = !this.darkModeEnabled;
    if (this.darkModeEnabled) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    localStorage.setItem('darkModePref', this.darkModeEnabled ? 'true' : 'false');
  }

  toggleBlindMode() {
    this.blindModeEnabled = !this.blindModeEnabled;
    if (this.blindModeEnabled) {
      document.body.classList.add('modo-baixa-visao');
    } else {
      document.body.classList.remove('modo-baixa-visao');
    }
    localStorage.setItem('blindModePref', this.blindModeEnabled ? 'true' : 'false');
  }

  toggleVLibras(reloadAfterToggle = false) {
    if (this.vlibrasLoading) {
      return;
    }

    this.vlibrasEnabled = !this.vlibrasEnabled;
    this.vlibrasLoadError = false;
    localStorage.setItem('vlibrasPref', this.vlibrasEnabled ? 'true' : 'false');

    if (reloadAfterToggle) {
      window.location.reload();
      return;
    }

    if (this.vlibrasEnabled) {
      this.scheduleVLibrasInit();
    }
  }

  @HostListener('window:open-accessibility-modal')
  openAccessibilityModal() {
    this.accessibilityModalOpen = true;
    setTimeout(() => {
      const firstBtn = document.getElementById('btn-darkmode-pref');
      if (firstBtn) {
        firstBtn.focus();
      }
    }, 150);
  }

  @HostListener('window:keydown', ['$event'])
  handleAccessibilityShortcut(event: KeyboardEvent) {
    const isMainContentShortcut = event.altKey && (event.key === '1' || event.code === 'Digit1');
    if (isMainContentShortcut) {
      event.preventDefault();
      this.skipToMainContent();
    }
  }

  skipToMainContent(event?: Event) {
    event?.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (!mainContent) {
      return;
    }

    mainContent.focus({ preventScroll: true });
    mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', '#main-content');
  }

  saveAccessibilityPrefs() {
    localStorage.setItem('accessibility_setup_done', 'true');
    
    // Save do-not-show-again and hide-bar preferences
    if (this.dontShowAgainChecked) {
      this.hideAccessibilityBar = true;
      localStorage.setItem('hideAccessibilityBarPref', 'true');
    } else {
      this.hideAccessibilityBar = false;
      localStorage.removeItem('hideAccessibilityBarPref');
    }

    this.accessibilityModalOpen = false;
  }

  initVLibras() {
    this.vlibrasLoading = true;
    this.vlibrasLoadError = false;

    if ((window as any).VLibras) {
      this.runVLibrasCallback(() => this.createVLibrasWidget());
      return;
    }

    const existingScript = document.getElementById('vlibras-plugin-script') as HTMLScriptElement | null;
    if (existingScript) {
      existingScript.addEventListener('load', () => this.runVLibrasCallback(() => this.createVLibrasWidget()), { once: true });
      existingScript.addEventListener('error', () => this.runVLibrasCallback(() => this.handleVLibrasLoadError()), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.id = 'vlibras-plugin-script';
    script.src = 'https://vlibras.gov.br/app/vlibras-plugin.js';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      setTimeout(() => {
        this.runVLibrasCallback(() => {
          if ((window as any).VLibras) {
            this.createVLibrasWidget();
          } else {
            this.handleVLibrasLoadError();
          }
        });
      }, 500);
    };
    script.onerror = () => this.runVLibrasCallback(() => this.handleVLibrasLoadError());
    document.body.appendChild(script);
  }

  private scheduleVLibrasInit() {
    this.changeDetectorRef.detectChanges();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.initVLibras());
    });
  }

  private runVLibrasCallback(callback: () => void) {
    this.ngZone.run(() => {
      callback();
      this.changeDetectorRef.detectChanges();
    });
  }

  private createVLibrasWidget() {
    try {
      if (!this.vlibrasInstance) {
        this.vlibrasInstance = new (window as any).VLibras.Widget('https://vlibras.gov.br/app');
      }
      this.vlibrasLoading = false;
    } catch {
      this.handleVLibrasLoadError();
    }
  }

  private handleVLibrasLoadError() {
    document.getElementById('vlibras-plugin-script')?.remove();
    this.vlibrasLoading = false;
    this.vlibrasEnabled = false;
    this.vlibrasLoadError = true;
    localStorage.setItem('vlibrasPref', 'false');
  }
}
